
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/dhi-website",
      function () {
        return require("private-next-pages/archive/dhi-website.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/dhi-website"])
      });
    }
  